import { DefaultRootState } from 'react-redux';

import { Proftest } from 'src/models/resume/resumeCommon.types';

export const selectApplicantResumeProftest = ({ applicantResume }: DefaultRootState): Proftest =>
    applicantResume?.proftest?.[0] || {};
